const features = [
  {
    icon: 'ri-scroll-to-bottom-line',
    title: '下拉式流畅阅读',
    desc: '专为漫画优化的纵向滚动阅读模式，一滑到底无缝衔接，告别翻页打断沉浸感。支持韩漫长条格式完美适配。',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    icon: 'ri-notification-3-line',
    title: '实时追更提醒',
    desc: '关注作品更新后第一时间推送通知，连载漫画不再错过任何一话。自定义提醒频率，掌控追更节奏。',
    color: 'bg-accent-100 text-accent-700',
  },
  {
    icon: 'ri-bookmark-line',
    title: '收藏与书签',
    desc: '一键收藏心水漫画，书签记录阅读进度。多设备同步你的书架，换设备也能无缝接着看。',
    color: 'bg-secondary-100 text-secondary-700',
  },
  {
    icon: 'ri-translate-2',
    title: '韩日国三语覆盖',
    desc: '汇聚韩漫、日漫、国漫三大语种优质内容。汉化组精翻、官方中文版、原版生肉多版本可选。',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    icon: 'ri-eye-off-line',
    title: '纯净阅读体验',
    desc: '无弹窗、无强制广告打断阅读。沉浸式深色模式保护视力，夜间阅读同样舒适。',
    color: 'bg-accent-100 text-accent-700',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-semibold rounded-full bg-secondary-100 text-secondary-700 mb-3 whitespace-nowrap">
            为什么选择99漫画
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            平台特色
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-md mx-auto">
            五项核心体验，打造最懂漫画读者的在线阅读平台
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {features.map((feat, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-lg p-6 border border-background-200/70 hover:border-primary-200 transition-all duration-200"
            >
              <span className={`w-12 h-12 rounded-lg flex items-center justify-center mb-4 ${feat.color}`}>
                <i className={`${feat.icon} text-xl`}></i>
              </span>
              <h3 className="text-base font-bold text-foreground-900 mb-2 whitespace-nowrap">
                {feat.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}